export default "__VITE_ASSET__e4283b04__"